<div class="w-full rounded-2xl bg-linear-(--my-gradient1) border-[#D9D9D9] shadow-(--my-shadow) pt-8 lg:pt-15 px-2 lg:px-5 mb-4 mb-md-0">
  <p class="text-white font-bold text-xl md:text-2xl lg:text-4xl xl:text-[45px] capitalize text-center mb-1">Welcome</p>
  <p class="text-white font-normal text-lg md:text-xl lg:text-2xl text-center">Verify Your Mobile Number</p>
  <div class="bg-white mt-6 lg:mt-10 w-full max-w-lg mx-auto rounded-xl shadow-lg">
    <div class="p-6 md:py-10 md:px-12 rounded-xl bg-white">
      <form>
        <div class="text-center mb-8">
          <h3 class="text-xl md:text-2xl font-bold text-gray-800">Enter OTP Code</h3>
          <p class="text-sm text-gray-500 mt-1">We sent a 6-digit verification code to your mobile number</p>
        </div>

        <div class="relative mb-6" [formGroup]="otpForm">
          <input type="text" id="mobilenum" formControlName="mobilenumber" readonly
            class="block px-3.5 pb-3 pt-3 w-full text-base text-gray-700 font-semibold bg-gray-50 rounded-lg border border-gray-200 focus:outline-none cursor-not-allowed peer"
            placeholder=" " />
          <label for="mobilenum"
            class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 bg-gray-50 px-2 start-2">
            Mobile Number
          </label>
        </div>

        <div class="relative mb-8">
          <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wider text-center mb-3">6-Digit Verification Code</label>
          <div class="flex items-center justify-between gap-2 md:gap-3">
            <input type="text" id="otp1" #otpInput maxlength="1"
              class="w-11 h-13 text-center text-xl font-bold text-gray-800 bg-white rounded-lg border-2 border-gray-300 focus:outline-none focus:border-c19725 focus:ring-2 focus:ring-c19725/20 transition-all"
              (keyup)="handleOtpInput($event, 0)" />
            <input type="text" id="otp2" #otpInput maxlength="1"
              class="w-11 h-13 text-center text-xl font-bold text-gray-800 bg-white rounded-lg border-2 border-gray-300 focus:outline-none focus:border-c19725 focus:ring-2 focus:ring-c19725/20 transition-all"
              (keyup)="handleOtpInput($event, 1)" />
            <input type="text" id="otp3" #otpInput maxlength="1"
              class="w-11 h-13 text-center text-xl font-bold text-gray-800 bg-white rounded-lg border-2 border-gray-300 focus:outline-none focus:border-c19725 focus:ring-2 focus:ring-c19725/20 transition-all"
              (keyup)="handleOtpInput($event, 2)" />
            <input type="text" id="otp4" #otpInput maxlength="1"
              class="w-11 h-13 text-center text-xl font-bold text-gray-800 bg-white rounded-lg border-2 border-gray-300 focus:outline-none focus:border-c19725 focus:ring-2 focus:ring-c19725/20 transition-all"
              (keyup)="handleOtpInput($event, 3)" />
            <input type="text" id="otp5" #otpInput maxlength="1"
              class="w-11 h-13 text-center text-xl font-bold text-gray-800 bg-white rounded-lg border-2 border-gray-300 focus:outline-none focus:border-c19725 focus:ring-2 focus:ring-c19725/20 transition-all"
              (keyup)="handleOtpInput($event, 4)" />
            <input type="text" id="otp6" #otpInput maxlength="1"
              class="w-11 h-13 text-center text-xl font-bold text-gray-800 bg-white rounded-lg border-2 border-gray-300 focus:outline-none focus:border-c19725 focus:ring-2 focus:ring-c19725/20 transition-all"
              (keyup)="handleOtpInput($event, 5)" />
          </div>
        </div>

        <!-- Submit Button -->
        <div class="flex items-center justify-center">
          <button type="button" (click)="verifyOtp()" [disabled]="isLoading"
            class="flex items-center justify-center cursor-pointer w-full py-3.5 text-lg font-bold text-white bg-c19725 border-2 border-c19725 hover:bg-[#d4a832] hover:shadow-md transition-all rounded-lg disabled:opacity-70 disabled:cursor-not-allowed">
            <ng-container *ngIf="!isLoading; else loadingTemplate">
              Verify & Proceed
            </ng-container>
            <ng-template #loadingTemplate>
              <i class="fas fa-spinner fa-spin mr-2"></i> Verifying...
            </ng-template>
          </button>
        </div>

        <p class="text-gray-500 font-medium text-sm text-center mt-6">
          Didn’t receive the code?
          <button type="button" (click)="resendOtp()"
            class="ml-1 text-c19725 font-bold hover:underline focus:outline-none">
            Resend Code
          </button>
        </p>
      </form>
    </div>
  </div>
</div>
